export const PASSCODE_MODAL = 'PASSCODE_MODAL';
export const INVALID_PASSCODE = 'INVALID_PASSCODE';
export const PASSCODE_FORM = 'PASSCODE_FORM';
